module.exports = __webpack_public_path__ + "img/demigods-promotions.50a9fac2.png";